import{jsx as e}from"react/jsx-runtime";import r from"./channelCardStrip.module.scss.js";const{badgeStyles:s}=r;function t({badgeText:r,className:t}){return e("div",{className:`${s} ${t}`,children:r})}export{t as default};
